import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useClient } from '../../hooks';

import { handleCallbackSuccess } from './handleCallbackSuccess';
import { handleCallbackError } from './handleCallbackError';
import { FederatedHandlerResponse } from './types';

export function useFederatedUser() {
  const router = useRouter();
  const { clientId, mfaToken } = useClient();
  const [federatedUser, setFederatedUser] = useState<FederatedHandlerResponse>({
    status: '',
    user: null,
  });

  useEffect(() => {
    const handleCallback = async (hash: string) => {
      if (hash.includes('#access_token') || hash.includes('#id_token')) {
        const { status, error, user } = await handleCallbackSuccess(
          hash,
          mfaToken,
          clientId
        );
        setFederatedUser({ status, error, user });
      } else if (hash.includes('#error_description')) {
        const { status, error, user } = handleCallbackError(hash);
        setFederatedUser({ status, error, user });
      } else
        setFederatedUser({
          status: 'error',
          error: 'Something went wrong. Please try again later',
          user: null,
        });
    };

    const federatedCb = router?.asPath?.includes('#')
      ? `#${router.asPath.split('#')[1]}`
      : '';

    if (clientId && federatedCb) {
      // Amplify assumes federated callback to be from hostedUI.
      // This is an attempt to avoid that assumption
      if (typeof window !== 'undefined')
        localStorage.removeItem('amplify-signin-with-hostedUI');
      handleCallback(federatedCb);
    }
  }, [clientId, router, mfaToken]);

  return {
    federatedStatus: federatedUser.status,
    federatedUser: federatedUser?.user
      ? {
          ...federatedUser?.user,
          attributes: {
            ...federatedUser?.user?.attributes,
            given_name: federatedUser?.user?.attributes.given_name || '',
            family_name: federatedUser?.user?.attributes.family_name || '',
          },
        }
      : federatedUser?.user,
    ...(federatedUser.error ? { error: federatedUser.error } : {}),
  } as const;
}
